import Flickity from 'flickity';

function PublicationSlider(el) {
  let flkty = null;
  const slider = el.querySelector('[data-slider]');
  const prev = el.querySelector('[data-prev]');
  const next = el.querySelector('[data-next]');

  function getFlickity() {
    if (!flkty) {
      flkty = new Flickity(slider, {
        cellSelector: '[data-slide]',
        prevNextButtons: false,
        pageDots: false,
        cellAlign: 'left',
        contain: true,
      });

      flkty.viewport.style.overflow = 'visible';
      flkty.resize();
    }

    return flkty;
  }

  function updateSlide(dir) {
    return function slideNavHandler() {
      if (dir === 'prev') {
        flkty.previous();
      }
      if (dir === 'next') {
        flkty.next();
      }
    };
  }

  function handleSlideChange(index) {
    prev.removeAttribute('disabled');
    next.removeAttribute('disabled');

    if (index === 0) {
      prev.setAttribute('disabled', '');
    }

    if (index === flkty.cells.length - 1) {
      next.setAttribute('disabled', '');
    }
  }

  function bind() {
    flkty.on('change', handleSlideChange);
    prev.addEventListener('click', updateSlide('prev'));
    next.addEventListener('click', updateSlide('next'));
  }

  function init() {
    getFlickity();
    handleSlideChange(0);
    bind();
  }

  init();
}

export default PublicationSlider;
